<template>

    <div class="group">

        <h2 class="heading_line _jp _alpha-down">
            <p><span>オーダー</span></p>
            <div class="line"></div>
        </h2>

        <div class="form_checkbox-wrap _small">

            <div class="item form_checkbox" v-for="(order,index) in $store.state.search.set.order" v-bind:key="index">
                <input type="checkbox" name="particular-order" class="" :id="'particular-order' + index" value="" v-on:change="changeOrder(order)">
                <label :for="'particular-order' + index">
                    <div class="check-mark"><span></span></div>
                    <span>{{ order.name }}</span>
                </label>
            </div>

        </div><!--/.item-wrap-->

    </div><!--/受注生産-->

</template>

<script>
    export default {
        data() {
            return {
                orders: [],
            }
        },
        methods: {
            changeOrder(order) {

                var itemIndex = '';
                var itemCheck = true;

                this.orders.forEach(function(item, index){
                    if (item.name == order.name) {
                        itemIndex = index;
                        itemCheck = false;
                    }
                });

                if (!itemCheck){
                    this.orders.splice(itemIndex, 1)
                } else {
                    this.orders.push(order)
                }
                this.$store.state.search.form.order = this.orders;
            }
        }
    }
</script>